export default __webpack_public_path__ + "static/media/blockchaingameicon.7183032a.png";